import * as React from 'react';
import { BrComponent } from '@bloomreach/react-sdk';

/**
 * This component wraps the component from the SDK that renders
 * any container-component from bloomreach based on the passed path.
 *
 * Any components inside this container will be rendered based on the
 * ComponentDefinitions we pass to SDK's page component.
 *
 * This component can be used to place certain containers in a page layout.
 * @example usage
 *   <Page>
 *     <CmsComponentSlot path="main/top-container" />
 *     <Cart />
 *     <SupportFooter />
 *     <CmsComponentSlot path="main/bottom-container" />
 *   </Page>
 */ const CmsComponentSlot = ({ path ='main' , children ,  })=>{
    return /*#__PURE__*/ React.createElement(BrComponent, {
        path: path,
        children: children
    });
};

export { CmsComponentSlot, CmsComponentSlot as default };
//# sourceMappingURL=Slot.js.map
